const { formatDateTime } = require('gui');
const extractSignature = require('./extractSignature');
const extractLocation = require('./extractLocation');
const extractName = require('./extractName');
const extractNameExclusive = require('./extractNameExclusive');
const { dictionaries: dicts } = require('core')

module.exports = function extractExternalEvents(orderDto, external) {
    if(external.IsInternal) {
        let internalEvent = {
            time: formatDateTime(external.Date, 'LT'),
            date: formatDateTime(external.Date, 'L'),
            ticks: external.Date,
            isActual: (external.Date !== undefined),
            isInternal: external.IsInternal,
            place: decideNorwegianOrEnglish(external),
            signature: extractSignature(external.Signature),
            signatureName: extractName(external.Signature),
            signatureNameExclusive: extractNameExclusive(external.Signature),
            location: extractLocation(external.Location),
            eventCode: external.EventCode
        };
        return internalEvent;
    }

    let externalEvent = {
        time: formatDateTime(external.Date, 'LT'),
        date: formatDateTime(external.Date, 'L'),
        ticks: external.Date,
        isActual: (external.Date !== undefined),
        url: external.Url,
        eventCode: external.EventCode,
        place: getEventPlace(external, orderDto)
    };

    return externalEvent;
}

function getEventPlace(external, orderDto) {
    if (external.InfoSource != 'Timpex Confirm') {
        external = negotiateHandlePreCarriageOrForwarderEvent(external, orderDto);
    } else {
        if (external.EventCode === 'LEV') { // IF forwarder should be 'LO'
            let party = orderDto.DeliveryParty;
            external.Info = 'Levert ' + [party.Name, party.Address].join(', ');
            external.InfoEnglish = 'Delivered ' + [party.Name, party.Address].join(', ');
        }
        else if (external.EventCode === 'HEN') { // IF preCarriage should be 'LA'
            let party = orderDto.DespatchParty;
            external.Info = 'Hentet ' + [party.Name, party.Address].join(', ');
            external.InfoEnglish = 'Picked up ' + [party.Name, party.Address].join(', ');
        }
        else if (external.Info) {
            external.InfoEnglish = external.Info;
        }
    }

    return decideNorwegianOrEnglish(external);
}

function negotiateHandlePreCarriageOrForwarderEvent(external, orderDto) {

    if(orderDto.PreCarriage && orderDto.PreCarriage.EdiPartId === external.InfoSource) {
        return handlePreCarriageEvent(external, orderDto);
    } else if(orderDto.Forwarder && orderDto.Forwarder.EdiPartId === external.InfoSource) {
        return handleForwarderEvent(external, orderDto);
    }
    external.InfoEnglish = external.Info;
    return  external;
}

function handlePreCarriageEvent(external, orderDto) {
    if (external.EventCode === 'LEV' || external.EventCode === 'LO') {
        let party = orderDto.PreCarriageLocation;
        external.Info = 'Losset ' + [party.Name, party.Address].join(', ');
        external.InfoEnglish = 'Unloaded ' + [party.Name, party.Address].join(', ');
    }
    else if (external.EventCode === 'HEN' || external.EventCode === 'LA') {
        let party = orderDto.DespatchParty;
        external.Info = 'Hentet ' + [party.Name, party.Address].join(', ');
        external.InfoEnglish = 'Picked up ' + [party.Name, party.Address].join(', ');

    }

    return external;
}

function handleForwarderEvent(external, orderDto) {
    if (external.EventCode === 'LEV' || external.EventCode === 'LO') {
        let party = orderDto.DeliveryParty;
        external.Info = 'Levert ' + [party.Name, party.Address].join(', ');
        external.InfoEnglish = 'Delivered ' + [party.Name, party.Address].join(', ');
    }
    else if (external.EventCode === 'HEN' || external.EventCode === 'LA') {
        let party = orderDto.ForwarderLocation;
        external.Info = 'Lastet ' + [party.Name, party.Address].join(', ');
        external.InfoEnglish = 'Loaded ' + [party.Name, party.Address].join(', ');
    }

    return external;
}

function decideNorwegianOrEnglish(external) {
    const languages = window.acceptedlanguages.accepted;
    var currentLanguage;

    for(var i = 0; i < languages.length; i++) {
        let language = languages[i];
        if(dicts[language]) {
            currentLanguage = language;
            break;
        }
    }

    if(currentLanguage === 'no' || !external.InfoEnglish)
        return external.Info;
    return external.InfoEnglish;
}
